import axios from "axios"

const INDUSTRIES_URL = process.env.REACT_APP_URI_INDUSTRY

const {
	REACT_APP_URI_VALIDATE_SITUACION_FISCAL: SITUACION_FISCAL_COMPLIANCE_URL,
	REACT_APP_URI_VALIDATE_OPINION_CUMPLIMIENTO: OPINION_CUMPLIMIENTO_URL,
	REACT_APP_URI_VALIDATE_REPSE: REPSE_URL,
	REACT_APP_URI_VALIDATE_OPINION_IMSS: OPINION_IMSS_URL,
	REACT_APP_URI_VALIDATE_OPINION_INFONAVIT: OPINION_INFONAVIT_URL,
	REACT_APP_URI_VALIDATE_SUA: SUA,
	REACT_APP_URI_VALIDATE_CARATULA_BANCARIA: CARATULA_BANCARIA,
} = process.env

// DOCUMENT ID OF THE DOCUMENTS THAT NEED VALIDATION OR DO SOMETHING AUTOMATIC
export const legalDocumentIDs = {
	constanciaSituacionFiscalFisica: "6564fc579081ec1ad85d7425",
	opinionPositivaSatFisica: "6564fd669081ec1ad85d742a",
	repseFisica: "663bb05df13a85d0d6b3a1d6",
	opinionPositivaImssFisica: "663bb05df13a85d0d6b3a1d3",
	opinionPositivaInfonavitFisica: "663bb05df13a85d0d6b3a1d2",
	suaFisica: "66c8eea61528ec0c0476340e",
	caratulaBancariaMXNFisica: "6564fc5c9081ec1ad85d7426",
	contratoDeServicioFisica: "682df3349f8ca7b3d6c536af",
	suaBimestralFisica: "682dfd01d718393550e451b5",
	finiquitosFisica: "682cbd9df3cbf577c0c99219",
	registroEntradaPlantaFisica: "682df66772206434ff29e2a9",

	constanciaSituacionFiscalMoral: "6564fd9b9081ec1ad85d7435",
	opinionPositivaSatMoral: "6564fdac9081ec1ad85d7438",
	repseMoral: "6564fd939081ec1ad85d7433",
	opinionPositivaImssMoral: "6564fdb09081ec1ad85d7439",
	opinionPositivaInfonavitMoral: "6564fdb59081ec1ad85d743a",
	suaMoral: "66c8eea61528ec0c0476340f",
	actaConstitutivaOriginalMoral: "6564fd6c9081ec1ad85d742b",
	idRepresentanteLegalMoral: "6564fd769081ec1ad85d742d",
	caratulaBancariaMXNMoral: "6564fda49081ec1ad85d7436",
	contratoDeServicioMoral: "682df3349f8ca7b3d6c536b0",
	suaBimestralMoral: "682dfd01d718393550e451b6",
	finiquitosMoral: "682cbd9df3cbf577c0c9921a",
	registroEntradaPlantaMoral: "682df66772206434ff29e2aa",
}

// VARIABLE TO VALIDATE WICH DOCUMENTS NEED TO REMOVE IF THE SUPPLIER DOES NOT HAVE REPSE
export const removeDocumentNoRepse = [
	legalDocumentIDs.repseFisica,
	legalDocumentIDs.opinionPositivaImssFisica,
	legalDocumentIDs.opinionPositivaInfonavitFisica,
	legalDocumentIDs.suaFisica,
	legalDocumentIDs.contratoDeServicioFisica,
	legalDocumentIDs.suaBimestralFisica,
	legalDocumentIDs.finiquitosFisica,
	legalDocumentIDs.registroEntradaPlantaFisica,
	
	legalDocumentIDs.repseMoral,
	legalDocumentIDs.opinionPositivaImssMoral,
	legalDocumentIDs.opinionPositivaInfonavitMoral,
	legalDocumentIDs.suaMoral,
	legalDocumentIDs.contratoDeServicioMoral,
	legalDocumentIDs.suaBimestralMoral,
	legalDocumentIDs.finiquitosMoral,
	legalDocumentIDs.registroEntradaPlantaMoral,
]

export const extraInfoIcon = [
	legalDocumentIDs.contratoDeServicioFisica,
	legalDocumentIDs.finiquitosFisica,
	legalDocumentIDs.registroEntradaPlantaFisica,
	legalDocumentIDs.finiquitosMoral,
	legalDocumentIDs.registroEntradaPlantaMoral,
	legalDocumentIDs.contratoDeServicioMoral,
]

// GET THE URL FOR THE DOCUMENT VALIDATION
const getDocumentUrl = async (documentID) => {
	switch (documentID) {
		case legalDocumentIDs.constanciaSituacionFiscalFisica:
		case legalDocumentIDs.constanciaSituacionFiscalMoral:
			return SITUACION_FISCAL_COMPLIANCE_URL
		case legalDocumentIDs.opinionPositivaSatFisica:
		case legalDocumentIDs.opinionPositivaSatMoral:
			return OPINION_CUMPLIMIENTO_URL
		case legalDocumentIDs.repseFisica:
		case legalDocumentIDs.repseMoral:
			return REPSE_URL
		case legalDocumentIDs.opinionPositivaImssFisica:
		case legalDocumentIDs.opinionPositivaImssMoral:
			return OPINION_IMSS_URL
		case legalDocumentIDs.opinionPositivaInfonavitFisica:
		case legalDocumentIDs.opinionPositivaInfonavitMoral:
			return OPINION_INFONAVIT_URL
		case legalDocumentIDs.suaFisica:
		case legalDocumentIDs.suaMoral:
		case legalDocumentIDs.suaBimestralFisica:
		case legalDocumentIDs.suaBimestralMoral:
			return SUA
		case legalDocumentIDs.caratulaBancariaMXNFisica:
		case legalDocumentIDs.caratulaBancariaMXNMoral:
			return CARATULA_BANCARIA
		default:
			return ""
	}
}

// FUNCTION TO VALIDATE THE DOCUMENT AND RETURN THE DATA
export const validateDocument = async (document, supplierId, companyName, supplierRfc, typeOfPerson) => {
	const url = await getDocumentUrl(document.documentID)

	if (!url) {
		return {
			errorMessage: "We could not validate your document, please try again later \n\n CODE: {URL}"
		}
	}

	const suaPeriod = document.documentID === legalDocumentIDs.suaFisica || document.documentID === legalDocumentIDs.suaMoral ? "Mensual" : "Bimestral"
	const isBimestral = document.documentID === legalDocumentIDs.suaBimestralFisica || document.documentID === legalDocumentIDs.suaBimestralMoral

	const formData = new FormData()
	formData.append("rfc", "temporal")
	formData.append("typeDocument", "SUA");
	formData.append("suaPeriod", suaPeriod);
	formData.append("supplierId", supplierId);
	formData.append("typeOfPerson", typeOfPerson);
	formData.append("companyName", companyName)
	formData.append("rfcSupplier", supplierRfc)
	isBimestral && formData.append("isBimestral", isBimestral)
	formData.append("document", document.document, `${document.yearCreatedAt}-${document.monthCreatedAt}-${document.document.name}`)
	formData.append("docDateCreation", JSON.stringify({
		year: document.yearCreatedAt,
		month: document.monthCreatedAt,
		day: document.dayCreatedAt,
	}))

	try {
		const { data } = await axios.post(url, formData)
		
		return data
	} catch (error) {
		console.log(error)
		
		return {
			errorMessage: error.response?.data?.message || "We could not validate your document, please try again later",
			errorMessagePercent: error.response?.data?.messagePercent
		}
	}
}

// Get all industries
export async function getAllIndustries() {
	try {
		const { data } = await axios.get(INDUSTRIES_URL)

		return data
	} catch (error) {
		console.log("Error al obtener las industrias")
	}
}

// Convert date to a readable format
export function convertDate(date) {
	if (!date) return "N/A"

	const formattedDate = new Date(date).toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' }).replace(/,/g, '')
	return formattedDate;
}
